/** Plaka metnini bosluksuz, buyuk harf gosterim icin normalize eder. */
export function formatPlateDisplay(plate: string | null | undefined): string {
  if (!plate) return "-";
  return plate.replace(/\s+/g, "").toUpperCase();
}
